import api from './api';

export interface MetaSoftwareRow {
  process_name: string;
  program_name: string | null;
  category_name: string | null;
  product_company: string | null;
  needcheck: string | null;
}

export interface MetaWebsiteRow {
  url: string;
  web_name: string | null;
  category_name: string | null;
  needcheck: string | null;
}

export interface MetaListResult<T> {
  items: T[];
  total: number;
}

export interface MetaListQuery {
  search?: string;
  mapped?: 'all' | 'mapped' | 'unmapped';
  page?: number;
  limit?: number;
}

export const dlpMetaService = {
  // ── 소프트웨어 ──
  async getSoftware(query: MetaListQuery): Promise<MetaListResult<MetaSoftwareRow>> {
    const res = await api.get<MetaListResult<MetaSoftwareRow>>('/dlp/meta/software', { params: query });
    return res.data;
  },
  async createSoftware(dto: { processName: string; programName: string; productCompany?: string }) {
    const res = await api.post('/dlp/meta/software', dto);
    return res.data;
  },
  async updateSoftware(dto: { processName: string; programName: string; productCompany?: string }) {
    const res = await api.patch('/dlp/meta/software', dto);
    return res.data;
  },

  // ── 웹사이트 ──
  async getWebsite(query: MetaListQuery): Promise<MetaListResult<MetaWebsiteRow>> {
    const res = await api.get<MetaListResult<MetaWebsiteRow>>('/dlp/meta/website', { params: query });
    return res.data;
  },
  async createWebsite(dto: { url: string; webName: string }) {
    const res = await api.post('/dlp/meta/website', dto);
    return res.data;
  },
  async updateWebsite(dto: { url: string; webName: string }) {
    const res = await api.patch('/dlp/meta/website', dto);
    return res.data;
  },
};
